import { ContractConfirmationDto } from "@/@client/Theasoft_ApiServer_Contracts"
import { useDefaultAttachmentsApiForControllerRoute } from "@/attachment-api"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { LabeledValue } from "@components/default-list/labeled-value"
import { DefaultListItem } from "@components/default-list/list-item"
import { Anchor, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface Props {
  confirmations: ContractConfirmationDto[]
}

export function ContractConfirmationsCard({ confirmations }: Props) {
  const contractDocumentAttachmentApi =
    useDefaultAttachmentsApiForControllerRoute("contracts/contract-documents")
  const { t } = useTranslation("app_server")
  if (confirmations.length === 0) return null
  return (
    <DetailsCard title={t("Documents")}>
      {confirmations.map((confirmation, index) => (
        <React.Fragment key={index}>
          <Text fz={"lg"} fw={"bold"}>
            {confirmation.documentNo}
          </Text>
          {confirmation.subject && (
            <DefaultListItem>
              <LabeledValue label={t("Subject")} value={confirmation.subject} />
            </DefaultListItem>
          )}
          {confirmation.summary && (
            <DefaultListItem>
              <LabeledValue label={t("Summary")} value={confirmation.summary} />
            </DefaultListItem>
          )}
          <DefaultListItem>
            <LabeledValue
              label={t("ValidityStatus")}
              value={t(confirmation.validityStatus)}
            />
          </DefaultListItem>
          {confirmation.contractDocumentAttachments.length > 0 && (
            <Text fw={500}>{t("Attachments")}</Text>
          )}
          {confirmation.contractDocumentAttachments.map(
            (contractDocumentAttachment, i) => (
              <Anchor
                fz={"lg"}
                key={i}
                target="_blank"
                href={contractDocumentAttachmentApi.getFileUrl(
                  contractDocumentAttachment.attachmentId,
                  contractDocumentAttachment.containerId
                )}
              >
                {contractDocumentAttachment.attachmentName}
              </Anchor>
            )
          )}
        </React.Fragment>
      ))}
    </DetailsCard>
  )
}
